import {
  Transaction_Type,
  type UserBalance,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import {
  type GetMyTransactionRequest,
  GetMyTransactionResponse,
  type GetMyTransactionsRequest,
  GetMyTransactionsResponse,
} from "schema/gen/es/chiikipoint/wallet/v2/service_pb";

// 現在の時間からの相対的な秒数を計算する関数
function getRelativeTimestamp(monthsAgo: number): bigint {
  const now = new Date();
  const date = new Date(
    now.getFullYear(),
    now.getMonth() - monthsAgo,
    now.getDate(),
  );
  return BigInt(Math.floor(date.getTime() / 1000));
}

// すべての期間のトランザクションデータを単一の配列に格納
const allTransactions = [
  // 0.5ヶ月前 (PAYMENT_PSINTERNAL - 複数ポイント種類)
  {
    id: "psinternal-payment-1",
    transactionDetails: [
      {
        transaction: {
          id: "ee8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i1",
          groupId: "psinternal-payment-1",
          userId: "1",
          type: Transaction_Type.PAYMENT_PSINTERNAL,
          balanceAddId: "1",
          amount: BigInt(-200),
          fundSourceId: "1",
          reason: "イベント参加費",
          createdAt: {
            seconds: getRelativeTimestamp(0.5),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
      {
        transaction: {
          id: "ee8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i2",
          groupId: "psinternal-payment-1",
          userId: "1",
          type: Transaction_Type.PAYMENT_PSINTERNAL,
          balanceAddId: "1",
          amount: BigInt(-300),
          fundSourceId: "2",
          reason: "イベント参加費",
          createdAt: {
            seconds: getRelativeTimestamp(0.5),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "キャンペーン",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 0.8ヶ月前 (PAYMENT_PSINTERNAL - 単一ポイント種類)
  {
    id: "psinternal-payment-2",
    transactionDetails: [
      {
        transaction: {
          id: "ff8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i3",
          groupId: "psinternal-payment-2",
          userId: "1",
          type: Transaction_Type.PAYMENT_PSINTERNAL,
          balanceAddId: "1",
          amount: BigInt(-150),
          fundSourceId: "1",
          reason: "サービス利用料",
          createdAt: {
            seconds: getRelativeTimestamp(0.8),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 1ヶ月前
  {
    id: "payment-1",
    transactionDetails: [
      {
        transaction: {
          id: "df880a2a-0101-45a7-a1cc-e2f4f7c1e4b7",
          groupId: "payment-1",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-100),
          fundSourceId: "1",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(1),
            nanos: 0,
          },
        },
        store: {
          id: "1",
          name: "みやポマート",
          fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.25783587179756,
            longitude: 140.87284595831724,
          },
          category: "コンビニ",
          iconUrl: "/misc/icons/company.png",
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
      {
        transaction: {
          id: "df880a2a-0101-45a7-a1cc-e2f4f7c1e4c8",
          groupId: "payment-1",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-150),
          fundSourceId: "2",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(1),
            nanos: 0,
          },
        },
        store: {
          id: "1",
          name: "みやポマート",
          fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.25783587179756,
            longitude: 140.87284595831724,
          },
          category: "コンビニ",
          iconUrl: "/misc/icons/company.png",
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "キャンペーン",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 1.2ヶ月前 (REFUND)
  {
    id: "payment-refund-1",
    transactionDetails: [
      {
        transaction: {
          id: "aa8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i0",
          groupId: "payment-refund-1",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-750),
          fundSourceId: "1",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(1.2),
            nanos: 0,
          },
        },
        store: {
          id: "4",
          name: "みやポファッション",
          fullAddress: "宮城県仙台市泉区泉中央1-1-1",
          city: "宮城県仙台市泉区",
          location: {
            latitude: 38.3214,
            longitude: 140.8805,
          },
          category: "ファッション",
          iconUrl: "/misc/sample/shop.png",
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
      {
        transaction: {
          id: "bb8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i0",
          groupId: "payment-refund-1",
          userId: "1",
          type: Transaction_Type.REFUND,
          balanceAddId: "1",
          amount: BigInt(750),
          fundSourceId: "1",
          reason: "返品返金",
          refundedGroupId: "payment-refund-1",
          refunderStaffId: "staff-456",
          createdAt: {
            seconds: getRelativeTimestamp(1.1),
            nanos: 0,
          },
        },
        store: {
          id: "4",
          name: "みやポファッション",
          fullAddress: "宮城県仙台市泉区泉中央1-1-1",
          city: "宮城県仙台市泉区",
          location: {
            latitude: 38.3214,
            longitude: 140.8805,
          },
          category: "ファッション",
          iconUrl: "/misc/sample/shop.png",
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 1.5ヶ月前 (TRANSFER_IN)
  {
    id: "transfer-in-recent",
    transactionDetails: [
      {
        transaction: {
          id: "cc8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i0",
          groupId: "transfer-in-recent",
          userId: "1",
          type: Transaction_Type.TRANSFER_IN,
          balanceAddId: "1",
          amount: BigInt(500),
          fundSourceId: "1",
          reason: "ポイント当選",
          transferUserId: "4",
          createdAt: {
            seconds: getRelativeTimestamp(1.5),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 2ヶ月前
  {
    id: "payment-2",
    transactionDetails: [
      {
        transaction: {
          id: "df880a2a-0101-45a7-a1cc-e2f4f7c1e4b8",
          groupId: "payment-2",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-1000),
          fundSourceId: "1",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(2),
            nanos: 0,
          },
        },
        store: {
          id: "1",
          name: "みやポマート",
          fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.25783587179756,
            longitude: 140.87284595831724,
          },
          category: "コンビニ",
          iconUrl: "/misc/icons/company.png",
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 2.5ヶ月前 (TRANSFER_OUT)
  {
    id: "transfer-out-recent",
    transactionDetails: [
      {
        transaction: {
          id: "dd8f0b23-f1c2-45a7-b3e4-d5c6f7g8h9i0",
          groupId: "transfer-out-recent",
          userId: "1",
          type: Transaction_Type.TRANSFER_OUT,
          balanceAddId: "1",
          amount: BigInt(-800),
          fundSourceId: "1",
          reason: "ポイント送金",
          transferUserId: "5",
          createdAt: {
            seconds: getRelativeTimestamp(2.5),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 3ヶ月前
  {
    id: "grant-1",
    transactionDetails: [
      {
        transaction: {
          id: "fedc1830-8f3f-40ef-b97e-015fad05bc74",
          groupId: "grant-1",
          userId: "1",
          type: Transaction_Type.GRANT,
          balanceAddId: "1",
          amount: BigInt(3000),
          fundSourceId: "1",
          reason: "ポイント抽選当選",
          createdAt: {
            seconds: getRelativeTimestamp(3),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "ポイント抽選",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 4ヶ月前
  {
    id: "payment-3",
    transactionDetails: [
      {
        transaction: {
          id: "cd8b0791-7162-4918-9666-78086c014c40",
          groupId: "payment-3",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-500),
          fundSourceId: "1",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(4),
            nanos: 0,
          },
        },
        store: {
          id: "1",
          name: "みやポスーパー",
          fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.25783587179756,
            longitude: 140.87284595831724,
          },
          category: "スーパー",
          iconUrl: "/misc/icons/company.png",
        },
      },
      {
        transaction: {
          id: "a4b72c9e-3f10-48d5-b6d1-5a7c8e9f2d3a",
          groupId: "payment-3",
          userId: "1",
          type: Transaction_Type.REFUND,
          balanceAddId: "1",
          amount: BigInt(500),
          fundSourceId: "1",
          reason: "返金",
          refundedGroupId: "payment-3",
          refunderStaffId: "staff-123",
          createdAt: {
            seconds: getRelativeTimestamp(4),
            nanos: 0,
          },
        },
        store: {
          id: "1",
          name: "みやポスーパー",
          fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.25783587179756,
            longitude: 140.87284595831724,
          },
          category: "スーパー",
          iconUrl: "/misc/icons/company.png",
        },
      },
    ],
  },
  // 5ヶ月前
  {
    id: "transfer-in-1",
    transactionDetails: [
      {
        transaction: {
          id: "7e9c2d4b-5a3f-4c8d-9e6b-1f2a3c4d5e6f",
          groupId: "transfer-in-1",
          userId: "1",
          type: Transaction_Type.TRANSFER_IN,
          balanceAddId: "1",
          amount: BigInt(1000),
          fundSourceId: "1",
          reason: "ポイント当選",
          transferUserId: "2",
          createdAt: {
            seconds: getRelativeTimestamp(5),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 6ヶ月前
  {
    id: "transfer-out-1",
    transactionDetails: [
      {
        transaction: {
          id: "3c4d5e6f-7a8b-9c0d-1e2f-3a4b5c6d7e8f",
          groupId: "transfer-out-1",
          userId: "1",
          type: Transaction_Type.TRANSFER_OUT,
          balanceAddId: "1",
          amount: BigInt(-500),
          fundSourceId: "1",
          reason: "ポイント送金",
          transferUserId: "3",
          createdAt: {
            seconds: getRelativeTimestamp(6),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "新規登録ポイント",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 7ヶ月前
  {
    id: "payment-old-1",
    transactionDetails: [
      {
        transaction: {
          id: "9a8b7c6d-5e4f-3g2h-1i0j-9k8l7m6n5o4p",
          groupId: "payment-old-1",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-2500),
          fundSourceId: "1",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(7),
            nanos: 0,
          },
        },
        store: {
          id: "2",
          name: "みやポカフェ",
          fullAddress: "宮城県仙台市青葉区国分町2-13-21",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.2649,
            longitude: 140.8695,
          },
          category: "カフェ",
          iconUrl: "/misc/sample/cafe.png",
        },
      },
    ],
  },
  // 9ヶ月前
  {
    id: "grant-old-1",
    transactionDetails: [
      {
        transaction: {
          id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
          groupId: "grant-old-1",
          userId: "1",
          type: Transaction_Type.GRANT,
          balanceAddId: "1",
          amount: BigInt(5000),
          fundSourceId: "1",
          reason: "初回登録ボーナス",
          createdAt: {
            seconds: getRelativeTimestamp(9),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c09",
          name: "登録ボーナス",
          forbidTransfer: false,
        },
      },
    ],
  },
  // 11ヶ月前
  {
    id: "payment-very-old-1",
    transactionDetails: [
      {
        transaction: {
          id: "5a4b3c2d-1e0f-9g8h-7i6j-5k4l3m2n1o0p",
          groupId: "payment-very-old-1",
          userId: "1",
          type: Transaction_Type.PAYMENT,
          balanceAddId: "1",
          amount: BigInt(-1500),
          fundSourceId: "1",
          reason: "支払い",
          createdAt: {
            seconds: getRelativeTimestamp(11),
            nanos: 0,
          },
        },
        store: {
          id: "3",
          name: "みやポ書店",
          fullAddress: "宮城県仙台市青葉区中央1-1-1",
          city: "宮城県仙台市青葉区",
          location: {
            latitude: 38.2605,
            longitude: 140.8798,
          },
          category: "書店",
          iconUrl: "/misc/sample/shop.png",
        },
      },
    ],
  },
  // 12ヶ月前
  {
    id: "grant-very-old-1",
    transactionDetails: [
      {
        transaction: {
          id: "0p9o8n7m-6l5k-4j3i-2h1g-0f9e8d7c6b5a",
          groupId: "grant-very-old-1",
          userId: "1",
          type: Transaction_Type.GRANT,
          balanceAddId: "1",
          amount: BigInt(10000),
          fundSourceId: "1",
          reason: "キャンペーンボーナス",
          createdAt: {
            seconds: getRelativeTimestamp(12),
            nanos: 0,
          },
        },
        fundSource: {
          id: "0191f997-b5fc-7732-9303-a06f08183c10",
          name: "キャンペーン",
          forbidTransfer: false,
        },
      },
    ],
  },
];

export async function handleGetMyTransactions(req?: GetMyTransactionsRequest) {
  // 0.5秒の遅延を追加
  await new Promise((resolve) => setTimeout(resolve, 500));

  // リクエストからページネーションパラメータを取得
  const offsetSeconds = req?.pagination?.offset?.seconds
    ? Number(req.pagination.offset.seconds)
    : null;
  const limitSeconds = req?.pagination?.limit?.seconds
    ? Number(req.pagination.limit.seconds)
    : null;

  console.log(`Mock API: offset=${offsetSeconds}, limit=${limitSeconds}`);

  // offsetがない場合は最新データ（3ヶ月分）を返す（初回ロード）
  if (!offsetSeconds || !limitSeconds) {
    // 現在から3ヶ月前までのデータをフィルタリング
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    const threeMonthsAgoSeconds = Math.floor(threeMonthsAgo.getTime() / 1000);

    const filteredTransactions = allTransactions.filter((txg) => {
      const baseTransactionTimestamp = Number(
        txg.transactionDetails[0].transaction?.createdAt?.seconds || 0,
      );
      return baseTransactionTimestamp >= threeMonthsAgoSeconds;
    });

    return new GetMyTransactionsResponse({
      transactionGroups: filteredTransactions,
    });
  }

  // offsetとlimitに基づいてデータをフィルタリング
  const filteredTransactions = allTransactions.filter((txg) => {
    const baseTransactionTimestamp = Number(
      txg.transactionDetails[0].transaction?.createdAt?.seconds || 0,
    );
    return (
      baseTransactionTimestamp <= offsetSeconds &&
      baseTransactionTimestamp >= limitSeconds
    );
  });

  return new GetMyTransactionsResponse({
    transactionGroups: filteredTransactions,
  });
}

// UserBalanceを生成するヘルパー関数
function generateUserBalance(
  transactionDetails: (typeof allTransactions)[0]["transactionDetails"],
): UserBalance[] {
  const baseTransaction = transactionDetails[0].transaction;
  if (!baseTransaction) return [];

  // 2030年2月末の有効期限
  const expireAt = {
    seconds: BigInt(1898863199),
    nanos: 0,
  };

  if (
    baseTransaction.type === Transaction_Type.GRANT ||
    baseTransaction.type === Transaction_Type.REFUND ||
    baseTransaction.type === Transaction_Type.TRANSFER_IN ||
    baseTransaction.type === Transaction_Type.TRANSFER_OUT
  ) {
    return [
      {
        addId: `balance-${baseTransaction.id}`,
        userId: baseTransaction.userId,
        fundSourceId: baseTransaction.fundSourceId,
        amount: baseTransaction.amount,
        expireAt,
      } as UserBalance,
    ];
  }

  // その他のタイプは空の配列を返す
  return [];
}

export async function handleGetMyTransaction(req: GetMyTransactionRequest) {
  // 0.5秒の遅延を追加
  await new Promise((resolve) => setTimeout(resolve, 500));

  // トランザクショングループIDに基づいて特定のトランザクションを検索
  const transactionGroup = allTransactions.find(
    (txg) => txg.id === req.transactionGroupId,
  );

  if (transactionGroup) {
    // balancesを生成
    const balances = generateUserBalance(transactionGroup.transactionDetails);

    return new GetMyTransactionResponse({
      transactionGroup,
      balances,
    });
  }

  throw new Error("transaction group not found");
}
